import {InputNumber} from "antd";
import React from "react";
import {InputWrapper, SplitInputWrapperProps} from "../../functions";
import {NumberInputBoxProps} from "./interface";
import {toLowerCaseWithUnderscore} from "../../../AgGridWrapper/utils/commonFunctions";
import {validations} from "../../../../config/validations/validations";

const NumberInputBox: React.FC<NumberInputBoxProps> = (props) => {
    const {
        formProps: {rules = [validations.number()], ...formProps},
        inputProps,
    } = SplitInputWrapperProps(props);

    if (formProps?.required) {
        rules.filter((rule: any) => rule.required).length === 0 &&
            rules.push(validations.required.text());
    }

    if (rules.length === 0) {
        rules.filter(
            (rule: any) =>
                rule.type === "number" || rule.type === "integer" || rule.type === "float"
        ).length === 0 && rules.push(validations.number());
    }

    return (
        <InputWrapper
            name={formProps?.label && toLowerCaseWithUnderscore(formProps?.label)}
            rules={rules}
            {...formProps}
        >
            <InputNumber placeholder={formProps?.label} {...inputProps} />
        </InputWrapper>
    );
};

export default NumberInputBox;
